<template>
    <form @submit.prevent="submit">
        <div class="mb-3">
            <label
                for="agency"
                class="form-label"
                >Agency:</label
            >
            <SelectField
                id="agency"
                v-model="selectedOri"
                :select-items="agencies"
                :is-horizontal="false"
                :is-required="true">
            </SelectField>
        </div>
        <div class="mb-3">
            <label
                for="year"
                class="form-label"
                >Year:</label
            >
            <SelectField
                id="year"
                v-model="year"
                :select-items="years"
                :is-horizontal="false"
                :is-required="true">
            </SelectField>
        </div>
        <div class="mb-3">
            <label
                for="month"
                class="form-label"
                >Month:</label
            >
            <SelectField
                id="month"
                v-model="month"
                :select-items="months"
                :is-horizontal="false"
                :is-required="true">
            </SelectField>
        </div>
        <div class="text-end">
            <b-button
                type="submit"
                :loading="loading"
                :disabled="!canSubmit">
                Submit
            </b-button>
        </div>
    </form>
</template>
<script lang="ts" setup>
import SelectField from "../Misc/SelectField.vue";
import {BButton} from "../BButton";
import {useCommunityPolicingStore} from "@/stores/communityPolicingStore";
import {storeToRefs} from "pinia";
import {ref, watch, computed} from "vue";
import {SelectItem} from "@/types";
import {handleError} from "@/stores/storeHelper";
const communityPolicingStore = useCommunityPolicingStore();
const {getOrisForSelectList: agencies} = storeToRefs(communityPolicingStore);
const selectedOri = ref("");
const year = ref(0);
const years = ref([] as SelectItem[]);
const month = ref(0);
const months = ref([] as SelectItem[]);
const loading = ref<boolean>(false);
const canSubmit = computed(() => {
    return year.value && month.value && selectedOri.value != null;
});

watch(
    () => selectedOri.value,
    async (val: any) => {
        if (selectedOri.value) {
            communityPolicingStore.setSelectedOri(selectedOri.value);
            await communityPolicingStore.fetchDatasetDetailsForOri();
            generateYearArray();
        }
    }
);

watch(
    () => year.value,
    async (val: any) => {
        generateMonthArray();
    }
);

const submit = async () => {
    loading.value = true;
    try {
        await communityPolicingStore.submitZeroReport(selectedOri.value, year.value, month.value);
        window.location.href = "dataupload.aspx?source=6";
    } catch (error) {
        handleError(error);
    } finally {
        loading.value = false;
    }
};

function generateMonthArray() {
    if (year.value === 0) {
        return [];
    }

    var data = communityPolicingStore.getDetailsForCurrentDataset;
    months.value = getMonthsAsSelectItemArray();

    let endDate = data.agency_end_date != undefined ? new Date(data.agency_end_date) : new Date(Date.now());
    let startDate = data.agency_start_date != undefined ? new Date(data.agency_start_date) : new Date(data.start_date);
    let filtered = months.value;

    if (startDate.getFullYear() == endDate.getFullYear()) {
        filtered = months.value.filter((item) => {
            if (item.value > startDate.getMonth() && item.value <= endDate.getMonth()) return item;
        });
    } else {
        if (year.value == endDate.getFullYear()) {
            filtered = months.value.filter((item) => {
                if (item.value <= endDate.getMonth()) return item;
            });
        } else if (year.value == startDate.getFullYear()) {
            filtered = months.value.filter((item) => {
                if (item.value > startDate.getMonth()) return item;
            });
        } else {
            filtered = months.value;
        }
    }

    months.value = filtered.sort((n1, n2) => {
        if (n1.value < n2.value) {
            return 1;
        }
        if (n1.value > n2.value) {
            return -1;
        }
        return 0;
    });
}

function handleYearUpdate(newYear) {
    generateMonthArray();
}

function getMonthsAsSelectItemArray() {
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ] as const;

    let monthsArray = [] as SelectItem[];

    monthNames.map((value, index) => {
        monthsArray.push({label: value, value: index + 1} as SelectItem);
    });

    return monthsArray;
}
function generateYearArray() {
    var data = communityPolicingStore.getDetailsForCurrentDataset;

    years.value = [] as SelectItem[];

    if (data != undefined) {
        let endDate = data.agency_end_date != undefined ? new Date(data.agency_end_date) : new Date(Date.now());

        //Since we can't submit a zero report for the current month were going to hide the current year is we're still in january otherwise the month drop down is blank.
        if (endDate.getFullYear() === new Date(Date.now()).getFullYear() && endDate.getMonth() === 0) {
            endDate.setFullYear(endDate.getFullYear() - 1, 11);
        }

        let startDate =
            data.agency_start_date != undefined ? new Date(data.agency_start_date) : new Date(data.start_date);

        for (let i = endDate.getFullYear(); i >= startDate.getFullYear(); i--) {
            years.value.push({label: `${i}`, value: i} as SelectItem);
        }

        if (years.value.length > 0) {
            year.value = years.value[0].value;
            handleYearUpdate(year.value);
        }
    }
}
</script>
